// Module
var code = "<div class=\"js-property-group-separator\">\r\n    <div class=\"js-tercera-label\">{{.text}}</div>\r\n</div>";
// Exports
export default code;